import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

const AiSpeechStyles = (props) => {
    const data = {
        url: '/admin/ai/speech-styles',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/ai/speech-styles/{id}',
        userfilter:[
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: '',
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Built-in',
                source: 'system',
                type: 'boolean',
                editable: false,
                default: false,
                values: {
                    true: 'YES',
                    false: 'NO'
                },
                classnames: {
                    true: 'label label-warning',
                    false: 'label label-success'
                }
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }

    return (
        <Panel title="AI Speech Styles">
            <>            
                <Tabs tabs={aiTabs} />
                <DataResource
                    addButtonText="Create New Speech Style"
                    addButtonType="link"
                    addButtonLink="/ai/speech-styles/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    )
}

export default AiSpeechStyles;